import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'upperCase'
})
export class UpperCasePipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
